import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row gy-5 g-xl-10" }
const _hoisted_2 = { class: "col-xl-12 mb-5 mb-xl-10" }
const _hoisted_3 = { class: "row g-5 g-xl-10 h-xxl-50 mb-0 mb-xl-10" }
const _hoisted_4 = { class: "col-xxl-12" }
const _hoisted_5 = { class: "card card-flush" }
const _hoisted_6 = { class: "card-header pt-5" }
const _hoisted_7 = { class: "d-flex align-items-center position-relative my-1 max-sm-w-100" }
const _hoisted_8 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "card-toolbar max-sm-w-100" }
const _hoisted_11 = {
  class: "d-flex justify-content-end max-sm-w-100",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_12 = {
  key: 0,
  type: "button",
  class: "btn btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_update_shipment"
}
const _hoisted_13 = { class: "svg-icon svg-icon-3 svg-icon-primary m-0" }
const _hoisted_14 = { class: "card-body overflow-auto pb-0" }
const _hoisted_15 = { class: "table dataTable table-row-bordered table-hover align-middle fs-6 gy-5 mb-0" }
const _hoisted_16 = { class: "text-start text-gray-400 fw-bold text-uppercase gs-0" }
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, null, -1)
const _hoisted_23 = { class: "fw-bold text-gray-800" }
const _hoisted_24 = { class: "text-start" }
const _hoisted_25 = { class: "text-start" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "text-start" }
const _hoisted_28 = { class: "text-end" }
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "d-flex align-items-center justify-content-end gap-2" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "svg-icon svg-icon-3" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "svg-icon svg-icon-2" }
const _hoisted_36 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "svg-icon svg-icon-3" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  colspan: "6",
  class: "dataTables_empty py-4"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "card-footer d-flex justify-content-end pt-0 px-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-100 border-top" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_PermissionCommon = _resolveComponent("PermissionCommon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_UpdateShipment = _resolveComponent("UpdateShipment")!
  const _component_print_preview = _resolveComponent("print-preview")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                    onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchShipmentItems && _ctx.searchShipmentItems(...args))),
                    class: "form-control form-control-solid w-250px ps-14 max-sm-w-100",
                    placeholder: _ctx.t('common.search')
                  }, null, 40, _hoisted_9), [
                    [_vModelText, _ctx.search]
                  ]),
                  _withDirectives(_createElementVNode("span", {
                    class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
                    style: {"cursor":"pointer"},
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
                  }, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                  ], 512), [
                    [_vShow, _ctx.search != '']
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (
                      _ctx.OrderRequestOverviewData.order_progress ===
                      _ctx.OrderRequestProgress.Confirmed
                    )
                      ? (_openBlock(), _createElementBlock("button", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil009.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.createShipment")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])), [
                    [_directive_auth, { auth: ['update'] }]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("table", _hoisted_15, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_16, [
                      _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.t("orderRequest.shippingDate")), 1),
                      _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.t("orderRequest.carrier")), 1),
                      _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.t("orderRequest.trackingNo")), 1),
                      _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.t("orderRequest.totalQty")), 1),
                      _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.t("common.status")), 1),
                      _hoisted_22
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.shipment_items, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.formatDate(item.shipping_date)), 1),
                        _createElementVNode("td", _hoisted_25, [
                          _createTextVNode(_toDisplayString(item.__show.carrier) + " ", 1),
                          (item.service_provider < 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.t("orderRequest.pickUp")), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(item.tracking_no), 1),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(item.__show.total_qty), 1),
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge text-uppercase", _ctx.getShipmentStatusMap(Number(item.status))])
                          }, _toDisplayString(item.__show.status), 3)
                        ]),
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#modal_update_shipment",
                              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm m-0",
                              onClick: ($event: any) => (_ctx.editShipment(item.id))
                            }, [
                              _createElementVNode("span", _hoisted_33, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                              ])
                            ], 8, _hoisted_32)), [
                              [_directive_auth, { auth: ['update'] }]
                            ]),
                            _createVNode(_component_PermissionCommon, { role: { auth: ['export'] } }, {
                              default: _withCtx(() => [
                                (item.relation_shipment)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (item.relation_shipment.shipment_type != '2')
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                                            onClick: ($event: any) => (_ctx.fileExport(item))
                                          }, [
                                            _createElementVNode("span", _hoisted_35, [
                                              (!item.downloadDisabled)
                                                ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                                    key: 0,
                                                    src: "media/icons/duotune/arrows/arr044.svg"
                                                  }))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_36))
                                            ])
                                          ], 8, _hoisted_34))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            (_ctx.isCanPrint)
                              ? (_openBlock(), _createBlock(_component_el_popover, {
                                  key: 0,
                                  placement: "top",
                                  width: "auto",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm max-sm-hidden",
                                      onClick: ($event: any) => (_ctx.getPrintedSheet(item))
                                    }, [
                                      _createElementVNode("span", _hoisted_38, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/print.svg" })
                                      ])
                                    ], 8, _hoisted_37)
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t("common.print")) + " ", 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128)),
                    (_ctx.formData.shipment_items.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                          _createElementVNode("td", _hoisted_40, [
                            _createElementVNode("p", null, [
                              (!_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_41, "No data found"))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _hoisted_42
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.options.shipmentLoading]
    ]),
    _createVNode(_component_UpdateShipment, {
      id: _ctx.shipmentId,
      status: _ctx.OrderRequestOverviewData.order_progress,
      type: _ctx.OrderRequestOverviewData.type,
      onResetForm: _ctx.handleReset,
      onUpdateList: _ctx.refreshListAndDetail
    }, null, 8, ["id", "status", "type", "onResetForm", "onUpdateList"]),
    _createVNode(_component_print_preview, {
      ref: "printPreviewRef",
      postUrl: _ctx.options.printUrl
    }, null, 8, ["postUrl"])
  ], 64))
}